
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

// Define the LogoProps interface
interface LogoProps {
  isAuthenticated: boolean;
}

const Logo = ({ isAuthenticated }: LogoProps) => {
  return (
    <Link to={isAuthenticated ? "/dashboard" : "/"} className="flex items-center space-x-2">
      <div className="relative w-6 h-6 mr-1">
        <Zap 
          className="w-full h-full text-[#9b87f5]" 
          strokeWidth={2.5}
        />
      </div>
      <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-[#9b87f5] to-[#7E69AB]">
        RaiseSpark
      </span>
    </Link>
  );
};

export default Logo;
